module.exports = __webpack_public_path__ + "images/help/icon-plane@2x-663e2ffbc19985b04715897f89e78afa.png";